import {observer, classNames, React, pluralize, Fragment} from '@api'
import {useWhiteboardStore} from '@modules/whiteboard'
import * as css from './StatusBar.css'

export const WhiteboardFooter = observer<{ className?: string }>(function WhiteboardFooter({className}) {
  const {
    appState: {activeTool, rendererBounds, status},
    myPageState: {camera: {point: [cameraX, cameraY]}},
    settings: {
      ui: {viewport}
    }, selectedIds, mouseLocationVirtual, mouseLocationRaw, mouseLocationVirtualRelative,
    visibleShapes, isInSession, tools: {session},
    clipboard: {hasClipboardContents, clipboard}
  } = useWhiteboardStore()

  return (<div className={classNames(css.statusBar, className)}>
    <div className={css.left}>
      <div className={css.section}>{session?.type ?? activeTool}</div>
      <div className={css.section}>{status}</div>
      {!_.isEmpty(selectedIds) &&
	    <div className={css.section}>{selectedIds.length} {pluralize('shape', selectedIds.length)} selected</div>}

      <div className={css.section}>{visibleShapes.length.toLocaleString()} {_.capitalize(pluralize('shape', visibleShapes.length))}</div>

      {hasClipboardContents &&
	   <div className={css.section}>
         {clipboard.shapes.length} {_.capitalize(pluralize('shape', _.size(clipboard.shapes)))} on clipboard
	   </div>}
    </div>

    <div className={css.right}>
      <span className={css.section}>Camera: ({cameraX}, {cameraY})</span>
      {mouseLocationVirtual &&
	   <Fragment>
		   <span className={css.section}>Mouse (scr): ({mouseLocationRaw.x}, {mouseLocationRaw.y})</span>
		   <span className={css.section}>Mouse (vir): ({mouseLocationVirtual[0].toFixed!(0)}, {mouseLocationVirtual[1].toFixed!(0)})</span>
       <span className={css.section}>Mouse (vir + rel): ({mouseLocationVirtualRelative[0].toFixed!(0)}, {mouseLocationVirtualRelative[1].toFixed!(0)} / {(mouseLocationVirtualRelative[0] / viewport.width * 100).toFixed(0)}%, {(mouseLocationVirtualRelative[1] / viewport.height * 100).toFixed(0)}%)</span>

     </Fragment>}
      <span className={css.section}>Viewport: ({viewport?.minX?.toFixed!(0)}, {viewport.minY?.toFixed!(0)}), ({viewport?.maxX?.toFixed!(0)}, {viewport.maxY?.toFixed!(0)})</span>
      <span className={css.section}>Renderer: ({rendererBounds?.width}, {rendererBounds.height})</span>

    </div>
  </div>)
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/ToolsPanel/StatusBar.tsx